<div class="episode-area bg-ffffff pt-50" *ngIf="analyze_videos && analyze_videos.length">
    <div class="container">
      <div class="section-title d-flex align-items-center justify-content-between mb-4 mt-15">
        <h2 class="fw-bold mb-0">Nos dernières analyses</h2>
        <a 
          href="https://www.youtube.com/playlist?list=PLRoijlTTy4tg3ifJ0pq6Ti0PzWxaN5-at"
          target="_blank"
          class="browse-all-btn black-color"
        >
          Découvrir toutes nos vidéos d'analyse et d'interviews
          <i class="ri-arrow-right-s-line"></i>
        </a>
      </div>      
  
      <owl-carousel-o [options]="videoCarouselOptions">
        <ng-container>
          <ng-template carouselSlide *ngFor="let video of analyze_videos">
            <div class="episode-single-card shadow-sm border rounded overflow-hidden d-flex flex-column h-100">
              <app-youtube-lazy
                [videoId]="video.videoId" 
                [title]="video.title"
                class="rounded-top"
              ></app-youtube-lazy>

              <div class="episode-content p-3 d-flex flex-column justify-content-between flex-grow-1">
                <div class="d-flex justify-content-between align-items-center mb-2 small gap-2">
                    <span class="text-muted">{{ video.date | date:'mediumDate' }}</span>
                    <span class="badge d-inline-flex align-items-center gap-1 px-3 py-1 rounded-pill"
                          [ngClass]="{
                            'bg-primary-subtle text-primary fw-semibold': video.badge === 'INTERVIEW',
                            'bg-warning-subtle text-warning fw-semibold': video.badge === 'ANALYSE'
                          }">
                      <i class="ri-mic-line" *ngIf="video.badge === 'INTERVIEW'"></i>
                      <i class="ri-search-eye-line" *ngIf="video.badge === 'ANALYSE'"></i>
                      {{ video.badge }}
                    </span>
                </div>                  
                <h3 class="fs-6 fw-semibold text-dark mb-0">
                  {{ video.title }}
                </h3>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>

    </div>

</div>